import Avatar from '@material-ui/core/Avatar'
import { get } from 'lodash'
import Typography from '@material-ui/core/Typography'
import React from 'react'
import { useStyles } from './styles'

const CoachCard = ({ coach }) => {
  const classes = useStyles()
  return (
    <div className={classes.rowWrapped}>
      <Avatar src={get(coach, 'coachProfile.profilePhoto')}>
        {coach.name.substring(0, 1)}
      </Avatar>
      <div className={classes.infoWrapped}>
        <Typography
          variant="caption"
          className={`${classes.fontBolded} ${classes.captionText}`}
        >
          {coach.name}
        </Typography>
        <Typography variant="caption" className={classes.captionText}>
          {get(coach, 'coachProfile.title', '')}
        </Typography>
      </div>
    </div>
  )
}

export default CoachCard
